






















































import { Component, Provide, Watch, Vue } from 'vue-property-decorator';
import { TForm } from '@/plugins/podolib/lib/types';
import { Severity } from '@sentry/types';

type TFields = {
  consented: {
    value: boolean;
  };
};

@Component
export default class Newsletters extends Vue {
  @Provide() form: TForm<TFields> = {
    fields: {
      consented: {
        value: false,
      },
    },
    pending: false,
    error: null,
    success: false,
  };

  @Provide() selectedStepIndex: number = 1;

  get dialog(): boolean {
    return (
      this.$store.getters['pdc/doctor/termsAndConditionsConsented'] &&
      typeof this.$store.getters['pdc/doctor/newslettersConsented'] !== 'boolean'
    );
  }

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Populate form
      this.form.fields.consented.value = false;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
    }
  }

  @Watch('form.fields', { deep: true })
  onFormFieldsDeeplyChanged(newFormFields: TFields) {
    // To avoid flash css switch
    if (!this.dialog) return;
    // Reset flags
    this.form.success = false;
    this.form.error = null;
  }

  async save() {
    try {
      // @ts-ignore
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;
      // Try to patch the station ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'doctors',
        // identifier: this.$pdc.doctor!.current._id,
        params: {
          _id: this.$pdc.doctor!.current._id,
        },
        data: {
          newsletters: {
            consented: this.form.fields.consented.value,
          },
        },
      });
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('User NewsletterOptedIn', {
        value: this.form.fields.consented.value,
      });
      this.form.success = true;

      this.$pdc.bus!.emit('home:welcome-dialog:open');
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('User NewsletterOptedIn', e, {
        value: this.form.fields.consented.value,
      });
      // TODO : add error display
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Critical);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
}
